import { updatePage } from "./page";
import { updateCheckWallet } from "./check_wallet";
import { updateTokenAnalyzer } from "./token_analyzer";
import { updateAiCircle } from "./ai_circle";
import { updateNotification } from "./notification";
import { updateUserData } from "./user_data";
import { updateBlockchain } from "./blockchain";

const reducer = (state, action) => {
  return {
    page: updatePage(state, action),
    checkWallet: updateCheckWallet(state, action),
    tokenAnalyzer: updateTokenAnalyzer(state, action),
    aiCircle: updateAiCircle(state, action),
    notification: updateNotification(state, action),
    userData: updateUserData(state, action),
    blockchain: updateBlockchain(state, action)
  };
};

export default reducer;
